const CommonConstants = {
  COMPANY_TYPE: {
    MZ_MERCHANDISE: 'MZ_MERCHANDISE',
    GENERAL: 'GENERAL',
  },
  // CREATE_COMPANY_AND_ADMIN: 'CREATE_COMPANY_AND_ADMIN',
  // CREATE_COMPANY_ADMIN: 'CREATE_COMPANY_ADMIN',

  CREATE_STORE_AND_ADMIN: 'CREATE_STORE_AND_ADMIN',
  CREATE_STORE_ADMIN: 'CREATE_STORE_ADMIN',
  US_DISABLED_STATUS: 'disabled',
  US_ENABLED_STATUS: 'enabled',
  GATEWAY: {
    GATEWAY_ID_PATTERN: /^[a-zA-Z0-9:_-]+$/,
  },

  RELOAD_DEVICE_DATA_INTERVAL: 60000, // 1 MIN

  ALARM_FLUSHINGS: {
    OFF: 'OFF',
    ON_FOR_ALL: 'ON_FOR_ALL',
    ON_EXCEPT_POWER_OUTAGE: 'ON_EXCEPT_POWER_OUTAGE',
  },
  MAX_API_KEYS: 20
};

export default CommonConstants;
